import React from 'react'

import SelectProjectMulti from "../../../../app/quick-add/sections/view/components/forms/common-blocks/project-multi"
import FormManager from "../../../gd-form/common/form-manager"
import CustomView from "../../../model2/custom-view/custom-view"
import SummaryEventTypesBlock from "../../../../app/quick-add/sections/view/components/conditions/summary-event-types"
import {EventType} from "../../../gd/const/event"
import getAvailableProjectsByViewType from "../../functions/get-available-projects"
import {EntityType} from "../../../gd/const/item";

type EventsSummaryConditionsType = {
    projects    : ID[]
    eventTypes  : ID[]
}

type Props = {
    className?  : string

    view        : CustomView
    disabled?   : boolean
    onChange    : { (conditions: EventsSummaryConditionsType):void }
}

// const debug = "ViewEventsSummary_Conditions"
const debug = false

export default function ViewEventsSummary_Conditions(props: Props) {

    debug && console.log(debug, 'render', props)

    const onUserChange = () => {
        debug && console.log(debug, 'onUserChange')

        const result = form.getValues()

        const conditions: EventsSummaryConditionsType = {
            projects    : result.projects,
            eventTypes  : result.eventTypes,
        }

        debug && console.log(debug, 'onUserChange conditions', conditions)

        props.onChange(conditions)
    }

    const onParentSelect = (projects: ID[]) => {
        debug && console.log(debug, 'onParentSelect')

        form.onFormComponentValueChange('projects', projects)

        onUserChange()
    }

    const conditions = props.view.settings

    const initFormData: any = {
        projects    : conditions?.projects || [],
        eventTypes  : conditions?.eventTypes || [
            EventType.PROJECT_EVENT,
            EventType.PROJECT_MILESTONE,
            EventType.PROJECT_DEADLINE,
            EventType.COMPANY_EVENT,
            EventType.COMPANY_HOLIDAY,
            EventType.TASK_DEADLINE,
        ],
    }

    const formStructure = {
        fields          : {
            projects        : { type: 'select',   isRequired: false,  label: 'Projects'},
            eventTypes      : {
                type            : 'select',
                isRequired      : false,
                label           : 'Event type',
                validator       : (val:any) => val.length > 0 ? true : 'At least one type should be selected',
                onUserChange    : onUserChange},
        },
        isFormChanged   : true,
    }

    const form = new FormManager(formStructure, initFormData)

    const classes = Classes("ui5-form", props.className)

    return (
        <div className={classes}>
            <div className="tbl">
                <SelectProjectMulti form                = {form}
                                    formFieldName       = 'projects'
                                    availableProjects   = {getAvailableProjectsByViewType(props.view.type)}
                                    disabled            = {props.disabled}
                                    parentsFor          = {EntityType.PROJECT}
                                    onParentSelect      = {onParentSelect}/>

                <SummaryEventTypesBlock form            = {form}
                                        formFieldName   = 'eventTypes'
                                        disabled        = {props.disabled}/>
            </div>
        </div>
    )
}
